'use client';

import { NodeResort } from '@/utils/drupal-api/__generated__/graphql';
import { ListingsFacets } from '@/utils/platform-api/__generated__/graphql';
import { ClientBrandConfig } from 'types/brand-config';

import { CollapsedSearchButton } from '@/components/search/collapsed-search-button';
import { SearchBar } from '@/components/search/search-bar';
import { useStickySearchContext } from '@/components/search/sticky-search-context';

export type StickySearchContentProps = {
  brand: ClientBrandConfig;
  quickSearchTarget: string;
  resorts?: NodeResort[];
  showFilters?: boolean;
  searchButtonText?: string;
  facets?: ListingsFacets;
};

export const StickySearchContent = ({
  brand,
  quickSearchTarget,
  resorts,
  showFilters,
  searchButtonText,
  facets,
}: StickySearchContentProps) => {
  const { mobileExpanded, setMobileExpanded } = useStickySearchContext() ?? {
    mobileExpanded: false,
    setMobileExpanded: () => {},
  };

  return (
    <>
      <div className="w-full lg:hidden">
        {mobileExpanded ? (
          <SearchBar
            brand={brand}
            quickSearchTarget={quickSearchTarget}
            resorts={resorts}
            showFilters={showFilters}
            searchButtonText={searchButtonText}
            facets={facets}
            shouldSubmit={false}
            layout="stacked"
            onCollapse={() => setMobileExpanded(false)}
          />
        ) : (
          <CollapsedSearchButton
            brand={brand}
            resorts={resorts}
            listingFacets={facets}
            submitPath={quickSearchTarget}
            onExpand={() => setMobileExpanded(true)}
          />
        )}
      </div>
      <div className="hidden lg:block">
        <SearchBar
          brand={brand}
          quickSearchTarget={quickSearchTarget}
          resorts={resorts}
          showFilters={showFilters}
          searchButtonText={searchButtonText}
          facets={facets}
          shouldSubmit={false}
          layout="horizontal"
        />
      </div>
    </>
  );
};
